import { render } from "./ElephantMideaPage.vue?vue&type=template&id=18f0ea0d&scoped=true"
import script from "./ElephantMideaPage.vue?vue&type=script&lang=js"
export * from "./ElephantMideaPage.vue?vue&type=script&lang=js"

import "./ElephantMideaPage.vue?vue&type=style&index=0&id=18f0ea0d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f0ea0d"]])

export default __exports__